import {
  sitesOptions,
  getGmfFormats,
  getPracticeFilterGameformats,
  getCardsValues,
} from '@/helpers/constants'
import { rangeTableGroups } from '@/helpers/solution'
import { getAllCards } from '@/helpers/cards'

const mock = {
  categories: [
    {
      category_name: 'general',
      filters: [
        {
          field_name: 'big_blind',
          filter_type: 'SINGLE_CHOICE',
          filter_ui_type: 'INPUT_AND_SELECT',
          range_keys: null,
          available_choices: ['0.25', '0.50', '1.00', '2.00', '5.00'],
          available_type_choices: null,
          search_field_url: null,
          display_key: null,
          filter_key: null,
        },
        {
          field_name: 'blinds',
          filter_type: 'MULTIPLE_CHOICE',
          range_keys: null,
          available_choices: null,
          available_type_choices: null,
          search_field_url: 'blinds',
          display_key: 'big_blind',
          filter_key: 'id',
        },
        {
          field_name: 'gto_score',
          filter_type: 'SINGLE_CHOICE',
          filter_ui_type: 'INPUT_AND_SELECT',
          range_keys: null,
          available_choices: ['0.25', '0.5', '0.75', '1'],
          available_type_choices: null,
          search_field_url: null,
          display_key: null,
          filter_key: null,
        },
        {
          field_name: 'total_ev_loss',
          filter_type: 'SINGLE_CHOICE',
          filter_ui_type: 'INPUT_AND_SELECT',
          range_keys: null,
          available_choices: ['0.1', '1', '2', '5'],
          available_type_choices: null,
          search_field_url: null,
          display_key: null,
          filter_key: null,
        },
      ],
    },
  ],
  orderings: [],
}

function getLocalFiltersConfigs() {
  return {
    practiceStats: {
      // ffxs
      categories: [
        {
          category_name: 'general',
          filters: [
            {
              field_name: 'date',
              filter_type: 'RANGE',
              filter_ui_type: 'DATETIME',
              range_keys: ['created_at_after', 'created_at_before'],
            },
            {
              field_name: 'gameformat',
              filter_type: 'MULTIPLE_CHOICE',
              filter_ui_type: 'SELECT_EXPOSED',
              // filter_ui_type: 'SELECT',
              available_choices: ['Cash', 'HuSng', 'MTT', 'Spins'],
            },
          ],
        },
      ],
      orderings: [],
    },
    practiceSessions: {
      // ffps
      categories: [
        {
          category_name: 'general',
          filters: [
            {
              field_name: 'marked',
              filter_type: 'BOOL',
              filter_ui_type: 'STAR',
              available_choices: ['true'],
            },
            {
              field_name: 'date',
              filter_type: 'RANGE',
              filter_ui_type: 'DATETIME',
              range_keys: ['created_at_after', 'created_at_before'],
            },
            {
              field_name: 'gameformat',
              filter_type: 'MULTIPLE_CHOICE',
              filter_ui_type: 'SELECT_EXPOSED',
              available_choices: getPracticeFilterGameformats(),
            },
          ],
        },
      ],
      orderings: [],
    },
    analyzeHands: {
      // ffah
      categories: [
        {
          category_name: 'general',
          filters: [
            // TODO filters
            // file: '',
            // filename: '',

            {
              field_name: 'marked',
              filter_type: 'BOOL',
              filter_ui_type: 'STAR',
              available_choices: ['true'],
            },
            {
              field_name: 'file',
              filter_type: 'URL_CHOICE', // v1 only
              filter_ui_type: 'CHOICES_EXPOSED',
              filter_key: 'id',
            },
            {
              field_name: 'date',
              filter_type: 'RANGE',
              filter_ui_type: 'DATETIME',
              range_keys: ['date_played_after', 'date_played_before'],
            },
            {
              field_name: 'position',
              filter_type: 'MULTIPLE_CHOICE',
              filter_ui_type: 'SELECT',
              available_choices: [
                'UTG',
                'UTG+1',
                'UTG+2',
                'LJ',
                'HJ',
                'CO',
                'BTN',
                'SB',
                'BB',
                'STR',
              ],
            },
            {
              field_name: 'site',
              filter_type: 'MULTIPLE_CHOICE',
              filter_ui_type: 'SELECT',
              available_choices: sitesOptions().map(i => i.id),
            },
            {
              field_name: 'street',
              filter_type: 'MULTIPLE_CHOICE',
              filter_ui_type: 'SELECT',
              available_choices: ['preflop', 'postflop'],
            },
            {
              field_name: 'ev_mistake',
              filter_type: 'SINGLE_CHOICE',
              filter_ui_type: 'SELECT',
              available_choices: ['0', '-0.5', '-1', '-2', '-3', '-4', '-5'],
            },
            {
              field_name: 'amount_won',
              filter_type: 'MULTIPLE_CHOICE',
              filter_ui_type: 'SELECT',
              available_choices: ['10', '20', '50'],
            },
            {
              field_name: 'total_pot',
              filter_type: 'MULTIPLE_CHOICE',
              filter_ui_type: 'SELECT',
              available_choices: ['10', '20', '50'],
            },
            {
              field_name: 'hand',
              display_name: 'hands',
              filter_type: 'MULTIPLE_CHOICE',
              filter_ui_type: 'HAND',
              // available_choices: 'ite can be any cards combination - handled on filter body
            },
            {
              field_name: 'board',
              filter_type: 'SINGLE_CHOICE',
              filter_ui_type: 'BOARD',
              // available_choices: 'ite can be any cards combination - handled on filter body
            },
          ],
        },
      ],
      orderings: [],
    },
    practiceHands: {
      // ffph
      categories: [
        {
          category_name: 'general',
          filters: [
            // TODO filters
            // session: '',
            // session_name: '',
            // drill: '',
            // drill_name: '',

            {
              field_name: 'marked',
              filter_type: 'BOOL',
              filter_ui_type: 'STAR',
              available_choices: ['true'],
            },
            {
              field_name: 'session',
              filter_type: 'URL_CHOICE', // v1 only
              filter_ui_type: 'CHOICES_EXPOSED',
              filter_key: 'id',
            },
            {
              field_name: 'drill',
              filter_type: 'URL_CHOICE', // v1 only
              filter_ui_type: 'CHOICES_EXPOSED',
              filter_key: 'id',
            },
            {
              field_name: 'date',
              filter_type: 'RANGE',
              filter_ui_type: 'DATETIME',
              range_keys: ['created_at_after', 'created_at_before'],
            },
            {
              field_name: 'hero',
              filter_type: 'SINGLE_CHOICE',
              filter_ui_type: 'SELECT',
              available_choices: [
                'UTG',
                'UTG+1',
                'UTG+2',
                'LJ',
                'HJ',
                'CO',
                'BTN',
                'SB',
                'BB',
                'STR',
                'OOP',
                'IP',
              ],
            },
            {
              field_name: 'gameformat',
              filter_type: 'MULTIPLE_CHOICE',
              filter_ui_type: 'SELECT',
              available_choices: getPracticeFilterGameformats(),
            },
            {
              field_name: 'spot_type',
              filter_type: 'MULTIPLE_CHOICE',
              filter_ui_type: 'SELECT',
              available_choices: [
                'PREFLOP',
                'SRP',
                '3bet',
                '4bet',
                '5bet',
                'Squeeze',
                'limp',
                'iso',
              ],
            },
            {
              field_name: 'total_ev_loss',
              filter_type: 'SINGLE_CHOICE',
              available_choices: ['0', '0.25', '0.5', '1', '2', '5'],
              filter_ui_type: 'INPUT_AND_SELECT',
              range_keys: null,
              available_type_choices: null,
              search_field_url: null,
              display_key: null,
              filter_key: null,
            },
            {
              field_name: 'total_ev_loss_as_pot',
              filter_type: 'SINGLE_CHOICE',
              available_choices: ['0', '0.005', '0.01', '0.02', '0.05'],
              filter_ui_type: 'INPUT_AND_SELECT',
              range_keys: null,
              available_type_choices: null,
              search_field_url: null,
              display_key: null,
              filter_key: null,
            },
            {
              field_name: 'total_frequency_difference',
              filter_type: 'SINGLE_CHOICE',
              available_choices: ['0', '0.25', '0.5', '0.75', '1'],
              filter_ui_type: 'INPUT_AND_SELECT',
              range_keys: null,
              available_type_choices: null,
              search_field_url: null,
              display_key: null,
              filter_key: null,
            },
            {
              field_name: 'hand',
              filter_type: 'MULTIPLE_CHOICE',
              filter_ui_type: 'HAND',
              available_choices: rangeTableGroups(),
            },
          ],
        },
      ],
      orderings: [],
    },
    customSolutions: {
      // ffcs
      categories: [
        {
          category_name: 'general',
          filters: [
            {
              field_name: 'is_favorite',
              filter_type: 'BOOL',
              filter_ui_type: 'STAR',
              available_choices: ['true'],
            },
            {
              field_name: 'positions',
              filter_type: 'MULTIPLE_CHOICE',
              filter_ui_type: 'SELECT_WITH_ANYALL',
              available_choices: [
                'UTG',
                'UTG1',
                'UTG2',
                'LJ',
                'HJ',
                'CO',
                'BTN',
                'SB',
                'BB',
                // 'MP',
                'STR',
                'OOP',
                'IP',
              ],
            },
            {
              parent_field: 'positions',
              field_name: 'positions_anyall',
              filter_type: 'SINGLE_CHOICE',
              filter_ui_type: 'SELECT_ANYALL',
              available_choices: ['any', 'all'],
            },
            {
              field_name: 'starting_street',
              display_name: 'street',
              filter_type: 'SINGLE_CHOICE',
              filter_ui_type: 'SELECT',
              available_choices: ['PREFLOP', 'FLOP'],
            },
            {
              field_name: 'board',
              filter_type: 'SINGLE_CHOICE',
              filter_ui_type: 'BOARD',
              available_choices: getAllCards(),
            },
            {
              tag_type: 'custom_solutions', // !!! this is unique for all tags

              field_name: 'tags',
              filter_type: 'MULTIPLE_CHOICE',
              filter_ui_type: 'TAGS_SELECT',
              filter_key: 'id',
            },
            {
              parent_field: 'tags',
              field_name: 'tags_anyall',
              filter_type: 'SINGLE_CHOICE',
              filter_ui_type: 'SELECT_ANYALL',
              available_choices: ['any', 'all'],
            },
          ],
        },
      ],
      orderings: [],
    },
    savedRanges: {
      // ffsr
      categories: [
        {
          category_name: 'general',
          filters: [
            {
              tag_type: 'saved_ranges', // !!! this is unique for all tags

              field_name: 'tags',
              filter_type: 'MULTIPLE_CHOICE',
              filter_ui_type: 'TAGS_SELECT',
              filter_key: 'id',
            },
            {
              parent_field: 'tags',
              field_name: 'tags_anyall',
              filter_type: 'SINGLE_CHOICE',
              filter_ui_type: 'SELECT_ANYALL',
              available_choices: ['any', 'all'],
            },
          ],
        },
      ],
      orderings: [],
    },
    reportsFlopFilter: {
      // ffrf
      categories: [
        {
          category_name: 'general',
          filters: [
            {
              field_name: 'flop_suits',
              filter_type: 'MULTIPLE_CHOICE',
              filter_ui_type: 'SELECT',
              available_choices: ['rainbow', 'flush_draw', 'monotone'],
            },
            {
              field_name: 'flop_paired',
              filter_type: 'MULTIPLE_CHOICE',
              filter_ui_type: 'SELECT',
              available_choices: ['not_paired', 'paired', 'tripled'],
            },
            {
              field_name: 'flop_connectedness',
              filter_type: 'MULTIPLE_CHOICE',
              filter_ui_type: 'SELECT',
              available_choices: ['disconnected', 'oesd_possible', 'connected'],
            },
            {
              field_name: 'flop_subset',
              filter_type: 'SINGLE_CHOICE',
              filter_ui_type: 'SELECT',
              available_choices: ['25', '49', '85', '184'],
            },
            {
              field_name: 'flop_high_card',
              filter_type: 'MULTIPLE_CHOICE',
              filter_ui_type: 'SELECT',
              available_choices: getCardsValues(),
            },
            {
              field_name: 'flop_mid_card',
              filter_type: 'MULTIPLE_CHOICE',
              filter_ui_type: 'SELECT',
              available_choices: getCardsValues(),
            },
            {
              field_name: 'flop_low_card',
              filter_type: 'MULTIPLE_CHOICE',
              filter_ui_type: 'SELECT',
              available_choices: getCardsValues(),
            },
          ],
        },
      ],
      orderings: [],
    },
    savedSpots: {
      categories: [
        {
          category_name: 'general',
          filters: [
            {
              tag_type: 'saved_spots', // !!! this is unique for all tags

              field_name: 'tags',
              filter_type: 'MULTIPLE_CHOICE',
              filter_ui_type: 'TAGS_SELECT',
              filter_key: 'id',
            },
            {
              parent_field: 'tags',
              field_name: 'tags_anyall',
              filter_type: 'SINGLE_CHOICE',
              filter_ui_type: 'SELECT_ANYALL',
              available_choices: ['any', 'all'],
            },
          ],
        },
      ],
      orderings: [],
    },
    savedFilters: {
      categories: [
        {
          category_name: 'general',
          filters: [
            {
              tag_type: 'saved_filters', // !!! this is unique for all tags

              field_name: 'tags',
              filter_type: 'MULTIPLE_CHOICE',
              filter_ui_type: 'TAGS_SELECT',
              filter_key: 'id',
            },
            {
              parent_field: 'tags',
              field_name: 'tags_anyall',
              filter_type: 'SINGLE_CHOICE',
              filter_ui_type: 'SELECT_ANYALL',
              available_choices: ['any', 'all'],
            },
          ],
        },
      ],
      orderings: [],
    },
    savedTrees: {
      // ffts
      categories: [
        {
          category_name: 'general',
          filters: [
            {
              tag_type: 'saved_trees', // !!! this is unique for all tags

              field_name: 'tags',
              filter_type: 'MULTIPLE_CHOICE',
              filter_ui_type: 'TAGS_SELECT',
              filter_key: 'id',
            },
            {
              parent_field: 'tags',
              field_name: 'tags_anyall',
              filter_type: 'SINGLE_CHOICE',
              filter_ui_type: 'SELECT_ANYALL',
              available_choices: ['any', 'all'],
            },
          ],
        },
      ],
      orderings: [],
    },
    drillsFilter: {
      categories: [
        {
          category_name: 'general',
          filters: [
            {
              field_name: 'favorite',
              filter_type: 'BOOL',
              filter_ui_type: 'STAR',
              available_choices: ['true'],
            },
            {
              field_name: 'drill_type',
              filter_type: 'SINGLE_CHOICE',
              filter_ui_type: 'SELECT_EXPOSED',
              available_choices: ['my_drills', 'public_drills'],
            },
            {
              field_name: 'l_gmf_format',
              filter_type: 'MULTIPLE_CHOICE',
              filter_ui_type: 'SELECT_EXPOSED',
              available_choices: getGmfFormats(),
            },
            {
              tag_type: 'drills', // !!! this is unique for all tags

              field_name: 'tags',
              filter_type: 'MULTIPLE_CHOICE',
              filter_ui_type: 'TAGS_SELECT',
              filter_key: 'id',
            },
            {
              parent_field: 'tags',
              field_name: 'tags_anyall',
              filter_type: 'SINGLE_CHOICE',
              filter_ui_type: 'SELECT_ANYALL',
              available_choices: ['any', 'all'],
            },
          ],
        },
      ],
      orderings: [],
    },
  }
}

export {
  mock, //
  getLocalFiltersConfigs,
}
